import React, {PropTypes} from 'react';
import NoItemsToDisplay from '../NoItemsToDisplay.jsx';
import AccountDetailContainer from './AccountDetailContainer.jsx';
import EditAccountModalContainer from './EditAccountModalContainer.jsx';

const AccountsList = ({
  accountList
}) => (
    <div className="animated fadeIn"> 
    <div className="panel panel-primary">
      <div className="panel-heading row">
        <div className="col-sm-12">
          <h4 className="panel-title">
            <span>{'Accounts'}
              <a type="button"
                className="btn btn-link pull-right"
                href={!accountList || !accountList.createAccountUrl ? '#' : accountList.createAccountUrl}>
                <i className="fa fa-plus"/> 
                {'Add Account'}
              </a>
            </span>
          </h4>
        </div> 
      </div>
      <div className="panel-body">
        <div className="animated fadeIn flex wrap">
          <p className="row col-xs-12">All accounts associated with the Group.</p>
        </div>
        { !accountList || !accountList.accounts || accountList.accounts.length == 0 ? <NoItemsToDisplay/> : 
          <div className="list-group">
            { accountList.accounts ? accountList.accounts.map((item, index) => (
              <AccountDetailContainer key={index}   
                        {...item} /> 
              )) : null}
          </div>
        }
        <EditAccountModalContainer />
      </div>
    </div>
  </div>
);

AccountsList.defaultProps = { 
};

AccountsList.propTypes = { 
  accountList: PropTypes.object
};

export default AccountsList;


// WEBPACK FOOTER //
// ./src/features/finance/accounts/AccountsList.jsx